import { baseUrl } from '../../config/api/constants';

const fetchShopListEndpoint = (filter?: string) =>
  `${baseUrl}/v1/stores?${filter || ''}`;

export { fetchShopListEndpoint };
